import React from "react";
import { Check, ArrowRight } from "lucide-react";

const benefits = [
  "Fast on-tool setup — no tape, no square, no pencil",
  "Repeatable, identical spacing on every panel",
  "Professional finish that elevates your trade",
  "Consistent results across teams and shifts",
  "Engineered specifically for the electrical trade",
];

export const Solution = ({ onJoinClick }) => {
  return (
    <section
      id="solution"
      data-testid="solution-section"
      className="relative py-24 md:py-36 border-t border-[#27272A] bg-[#0A0A0A]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-6 order-2 lg:order-1">
            <div className="relative aspect-[4/3] max-w-lg">
              <div className="absolute -inset-6 bg-[#FF6B00]/10 blur-3xl" />
              <div className="relative h-full border border-[#27272A] bg-white rounded-sm metal-edge overflow-hidden">
                <img
                  src="https://customer-assets-lxgj4vgw.emergentagent.net/job_gland-positioning/artifacts/24aad6e35195bd81_IMG_2423.webp"
                  alt="AdjustaGland PRO — CAD engineering render"
                  className="absolute left-0 right-0 w-full object-contain"
                  style={{ top: "-125%", height: "350%" }}
                />
                <div className="absolute top-0 left-0 right-0 h-[8%] bg-white pointer-events-none" />
                <div className="absolute bottom-0 left-0 right-0 h-[8%] bg-white pointer-events-none" />
              </div>
            </div>

            {/* Caption below image */}
            <div className="max-w-lg mt-5 flex items-center justify-between gap-4">
              <div>
                <div className="font-display text-xl md:text-2xl">
                  AdjustaGland<span className="text-[#FF6B00]">™</span> PRO
                </div>
                <div className="font-mono-spec text-[10px] md:text-[11px] uppercase tracking-[0.2em] text-[#A1A1AA] mt-1">
                  REV · 03 · Multi-size · Trade Grade
                </div>
              </div>
              <div className="px-3 py-1.5 bg-[#FF6B00] text-black font-mono-spec text-[10px] uppercase tracking-[0.22em] font-bold shrink-0">
                Pat. Pend.
              </div>
            </div>
          </div>

          <div className="lg:col-span-6 order-1 lg:order-2">
            <span className="label-eyebrow">02 / The Solution</span>
            <h2
              data-testid="solution-headline"
              className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tighter mt-4"
            >
              One tool.
              <br />
              <span className="text-[#FF6B00]">Every gland.</span>
              <br />
              Every time.
            </h2>
            <p className="mt-6 text-[#A1A1AA] text-base md:text-lg max-w-xl leading-relaxed">
              AdjustaGland PRO replaces the entire manual marking workflow with a
              single, adjustable, trade-grade instrument. Engineered with
              electricians, for electricians — to deliver consistent professional
              results, panel after panel.
            </p>

            <ul className="mt-8 space-y-3" data-testid="solution-benefits-list">
              {benefits.map((b) => (
                <li
                  key={b}
                  className="flex items-start gap-3 text-[15px] md:text-base"
                >
                  <span className="mt-0.5 w-5 h-5 grid place-items-center bg-[#FF6B00] text-black rounded-sm flex-shrink-0">
                    <Check className="w-3.5 h-3.5" strokeWidth={3} />
                  </span>
                  <span className="text-white/90">{b}</span>
                </li>
              ))}
            </ul>

            <button
              data-testid="solution-join-btn"
              onClick={onJoinClick}
              className="btn-primary mt-10 group"
            >
              Get Early Access
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};
